<template>
  <div class="field-basic-info" v-if="isReady">
    <div class="field-row-wrapper" data-row-span="4">
      <Field
        :data="InputFirst"
        :parent="parent"
        :sectionid="sectionid"
        :pageid="pageid"
        @field:isvalid="evtValid"
        @field:isfocused="evtFocused"
        @field:value="evtValue"
        @field:change="evtChange"
      />
      <Field
        :data="InputMiddle"
        :parent="parent"
        :sectionid="sectionid"
        :pageid="pageid"
        @field:isvalid="evtValid"
        @field:isfocused="evtFocused"
        @field:value="evtValue"
        @field:change="evtChange"
      />
      <Field
        :data="InputLast"
        :parent="parent"
        :sectionid="sectionid"
        :pageid="pageid"
        @field:isvalid="evtValid"
        @field:isfocused="evtFocused"
        @field:value="evtValue"
        @field:change="evtChange"
      />
      <Field
        :data="InputSuffix"
        :parent="parent"
        :sectionid="sectionid"
        :pageid="pageid"
        @field:isvalid="evtValid"
        @field:isfocused="evtFocused"
        @field:value="evtValue"
        @field:change="evtChange"
      />
    </div>
    <div class="field-row-wrapper" data-row-span="4" v-if="false">
      <Field
        :data="InputLast"
        :parent="parent"
        :sectionid="sectionid"
        :pageid="pageid"
        @field:isvalid="evtValid"
        @field:isfocused="evtFocused"
        @field:value="evtValue"
        @field:change="evtChange"
      />
      <Field
        :data="InputSuffix"
        :parent="parent"
        :sectionid="sectionid"
        :pageid="pageid"
        @field:isvalid="evtValid"
        @field:isfocused="evtFocused"
        @field:value="evtValue"
        @field:change="evtChange"
      />
    </div>
    <div class="field-row-wrapper" data-row-span="4" v-if="false">
      <Field
        :data="InputEmail"
        :parent="parent"
        :sectionid="sectionid"
        :pageid="pageid"
        @field:isvalid="evtValid"
        @field:isfocused="evtFocused"
        @field:value="evtValue"
        @field:change="evtChange"
      />
      <Field
        :data="InputPhone"
        :parent="parent"
        :sectionid="sectionid"
        :pageid="pageid"
        @field:isvalid="evtValid"
        @field:isfocused="evtFocused"
        @field:value="evtValue"
        @field:change="evtChange"
      />
    </div>
  </div>
</template>

<script>
import PreApproveMe from '@/services/PreApproveMe.js'

export default {
  name: 'FieldBasicInfo',
  components: {},
  props: {
    data: Object,
    parent: Object,
    sectionid: String,
    pageid: String
  },
  data: () => {
    return {
      PreApproveMe,
      isReady: false,
      InputFirst: false,
      InputMiddle: false,
      InputLast: false,
      InputSuffix: false,
      InputEmail: false,
      InputPhone: false
    }
  },
  methods: {
    evtValid: function($event) {
      this.$emit('field:isvalid', $event)
      if ($event.Id == this.data.Id + '__first') {
        $event.Id = this.data.Id
        this.$emit('field:isvalid', $event)
      }
    },
    evtFocused: function($event) {
      this.$emit('field:isfocused', $event)
      if ($event.Id == this.data.Id + '__first') {
        $event.Id = this.data.Id
        this.$emit('field:isfocused', $event)
      }
    },
    evtValue: function($event) {
      this.$emit('field:value', $event)
      if ($event.Id == this.data.Id + '__first') {
        $event.Id = this.data.Id
        this.$emit('field:value', $event)
      }
    },
    evtChange: function($event) {
      this.$emit('field:change', $event)
      if ($event.Id == this.data.Id + '__first') {
        $event.Id = this.data.Id
        this.$emit('field:change', $event)
      }
    }
  },
  mounted: function() {
    this.InputFirst = {
      Id: this.data.Id + '__first',
      Type: 13,
      Text: 'First Name',
      Required: this.data.Required,
      FieldSpan: 1,
      // FieldSpan: 2,
      Value:
        this.data.Value && typeof this.data.Value.FirstName !== 'undefined'
          ? this.data.Value.FirstName
          : null
    }
    this.InputMiddle = {
      Id: this.data.Id + '__middle',
      Type: 13,
      Text: 'Middle name',
      Required: false,
      FieldSpan: 1,
      // FieldSpan: 2,
      Value:
        this.data.Value && typeof this.data.Value.MiddleName !== 'undefined'
          ? this.data.Value.MiddleName
          : null
    }
    this.InputLast = {
      Id: this.data.Id + '__last',
      Type: 13,
      Text: 'Last Name',
      Required: this.data.Required,
      FieldSpan: 1,
      // FieldSpan: 2,
      Value:
        this.data.Value && typeof this.data.Value.LastName !== 'undefined'
          ? this.data.Value.LastName
          : null
    }
    this.InputSuffix = {
      Id: this.data.Id + '__suffix',
      Type: 13,
      Text: 'Suffix',
      Required: false,
      FieldSpan: 1,
      // FieldSpan: 2,
      Value:
        this.data.Value && typeof this.data.Value.Suffix !== 'undefined'
          ? this.data.Value.Suffix
          : null
    }
    this.InputEmail = {
      Id: this.data.Id + '__email',
      Type: 13,
      Text: 'Email Address',
      Required: this.data.Required,
      FieldSpan: 1,
      // FieldSpan: 2,
      Value:
        this.data.Value && typeof this.data.Value.Email !== 'undefined'
          ? this.data.Value.Email
          : null
    }
    this.InputPhone = {
      Id: this.data.Id + '__phone',
      Type: 13,
      Text: 'Phone Number',
      Required: this.data.Required,
      FieldSpan: 1,
      // FieldSpan: 2,
      Value:
        this.data.Value && typeof this.data.Value.Phone !== 'undefined'
          ? this.data.Value.Phone
          : null
    }
    this.isReady = true
  }
}
</script>

<style scoped lang="scss">
.field-basic-info {
}
</style>
